import { PlanComparisonView } from '@client/components/ltc-financial-planning/PlanComparisonView';
import { useLtcPlanComparison } from '@client/hooks/useLtcPlanComparison';

import { StepContentProps } from '../types';

export function ComparisonStep(props: StepContentProps) {
  const {
    projectedLtcCost,
    comparison,
    policyCoverage,
    chosenPolicy,
    fundingBreakdown,
    protectedAssets,
    totalPolicyCost,
    netDifference,
  } = useLtcPlanComparison();

  return (
    <div className="py-8">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">Your Plan Comparison</h1>
        <p className="mx-auto mt-3 max-w-2xl text-base text-gray-700">
          See how adding insurance coverage improves your long-term care protection while keeping
          your priority assets safe.
        </p>
      </div>

      <PlanComparisonView
        projectedLtcCost={projectedLtcCost}
        comparison={comparison}
        selectedPolicy={{
          name: chosenPolicy?.productName || 'Selected Policy',
          coverage: policyCoverage,
        }}
        fundingBreakdown={fundingBreakdown}
        protectedAssets={protectedAssets}
        totalPolicyCost={totalPolicyCost}
        netDifference={netDifference}
        className="mx-auto mt-8 max-w-4xl"
      />
    </div>
  );
}
